/* eslint-disable no-unused-vars */
import React from 'react';
import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import {
  VIEW_OPPORTUNITY,
  OPPORTUNITY_MEMBER_ROLE,
  APPLICATION_SUBMISSION_FILTERS,
} from '@app/apollo/queries';
import { addApolloState, initializeApollorWithQueries } from '@app/config/apollo';
import ViewOpportunityDashboardTemplate from '@app/components/templates/ViewOpportunityDashboard';
import SubmissionsForm from '@app/components/organisms/opportunities/OpportunitySubmissions';
import HeaderWithSidebar from '@app/components/templates/HeaderWithSidebar';
import GeneralFields from '@app/components/organisms/opportunity-wizard/WizardForm/GeneralFields';

const OpportunitySubmissionsPage = () => {
  const router = useRouter();
  const { slug } = router.query;

  const {
    data: { opportunity } = {},
    loading: opportunityLoading,
    refetch,
  } = useQuery(VIEW_OPPORTUNITY, {
    variables: { slug },
    skip: !slug,
  });

  const { data: { opportunityMemberRole } = {}, loading: opportunityMemberRoleLoading } = useQuery(
    OPPORTUNITY_MEMBER_ROLE,
    {
      variables: { id: opportunity?.id },
      skip: !opportunity?.id,
    }
  );

  const {
    data: { applicationSubmissionFilters } = {},
    // loading: applicationSubmissionFiltersLoading
  } = useQuery(APPLICATION_SUBMISSION_FILTERS, {
    variables: { opportunitySlug: slug },
    skip: !slug,
  });

  return !opportunityLoading && !opportunityMemberRoleLoading ? (
    <ViewOpportunityDashboardTemplate
      refetch={refetch}
      opportunity={opportunity}
      opportunityMemberRole={opportunityMemberRole}
    >
      {/* {!applicationSubmissionFiltersLoading && */}
      <SubmissionsForm
        opportunity={opportunity}
        opportunityMemberRole={opportunityMemberRole}
        refetchOpportunity={refetch}
        applicationSubmissionFilters={applicationSubmissionFilters}
      />
      {/* } */}
    </ViewOpportunityDashboardTemplate>
  ) : (
    <HeaderWithSidebar>
      {Array.from(new Array(5)).map((e, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <GeneralFields.Skeleton key={`skeleton-${i}`} />
      ))}
    </HeaderWithSidebar>
  );
};

export async function getServerSideProps(ctx) {
  const { slug } = ctx.query;

  const {
    apolloClient,
    data: [{ opportunity } = {}],
  } = await initializeApollorWithQueries(ctx, [
    {
      query: VIEW_OPPORTUNITY,
      variables: { slug },
      skip: !slug,
    },
  ]);

  return addApolloState(apolloClient, {
    props: {
      namespacesRequired: ['common', 'dashboard', 'wizard', 'applications'],
    },
    notFound: !opportunity,
  });
}

export default OpportunitySubmissionsPage;
